import { findCachedEntity } from '@src/store/contentEntities/contentEntities';
import { useEntityLoader, type UseEntityLoaderProps } from './useEntityLoader';
import { useMemo } from 'react';

export const useEntityByIdentifier = (props: UseEntityLoaderProps) => {
    const { entityType, entityIdentifier = '' } = props;
    const { entityId, load, loadStatus, error } = useEntityLoader({ entityType, entityIdentifier });

    const entity = useMemo(() => findCachedEntity(entityType, entityIdentifier), [entityType, entityIdentifier]);

    return {
        entity,
        entityId: entity?.id || entityId,
        load,
        loadStatus,
        error,
    };
};
